export default __webpack_public_path__ + "static/media/1.d834bb76.png";